import * as actionTypes from './actionTypes';

/**
 * Get output mappings for a version
 */
export const getOutputMappings = (payload) => ({
    type: actionTypes.GET_OUTPUT_MAPPINGS,
    payload
});

/**
 * Reprocess output mappings for a version
 */
export const reprocessOutputMappings = (versionId) => ({
    type: actionTypes.REPROCESS_OUTPUT_MAPPINGS,
    versionId
});

export const getSingleOutputMapping = (payload) => ({
    type: actionTypes.GET_SINGLE_OUTPUT_MAPPING,
    payload
});
